
@switch (subset.type) {
  @case ('ADDITIONS_INDEX') {
    <!-- todo: Дождаться пока на бекенде сделают 'addition1', 'addition2' вместо 1, 2
    и доделать это место  -->
    <span class="description">{{ subset.description }}:</span> {{ subset.value }}<br>
  }
  @case ('SELECTABLE') {
    <span class="description">{{ subset.description }}: </span>
    <span>{{ getSelectedLabelByValue(subset.values, subset.selected) }}</span>
  }
  @case ('ENTITY') {
    <span class="description">{{ subset.description }}: </span>
    <span>{{ getNameById(subset.id, subset.entity) }}</span>
  }
  @case ('SWITCHABLE') {
    <mat-checkbox [checked]="subset.value" class="readonly-checkbox">{{ subset.description }}</mat-checkbox>
  }
  @case ('FILE') {
    <div class="centred-align">
      <span class="description">{{ subset.description }}:</span>
      <img [src]="'data:' + subset.extension + ';base64,' + subset.value" class="file-preview" [alt]="'CONTROLS.FILE.no_image' | translate">
    </div>
  }
  @case ('RULE_SET') {
    <span class="description">{{ subset.description }}</span>
    <app-rule-view [border]="true"
      [rule]="subset.value">
    </app-rule-view>
  }
  @case ('SUBSET') {
    <div class="description">{{ subset.description }}</div>
    @for (subsetItem of subset.values; track subsetItem) {
      <div class="subset-view">
        <app-subset-view [subset]="subsetItem"
          [goods]="goods"
          [senders]="senders"
          [statuses]="statuses"
          [storehouses]="storehouses">
        </app-subset-view>
      </div>
    }
  }
  @case ('NUMERIC') {
    <span class="description">{{ subset.description }}:</span> {{ subset.value }}<br>
  }
  @case ('SHORT_TEXT') {
    <span class="description">{{ subset.description }}:</span> {{ subset.value }}<br>
  }
}
